import { createServiceSchema } from './structuredData';

interface ServiceSEO {
  title: string;
  description: string;
  keywords: string;
  url: string;
  image: string;
  structuredData: any;
}

export const getServiceSEO = (serviceId: string, serviceData: any): ServiceSEO => {
  const seoData: Record<string, ServiceSEO> = {
    'banos-portatiles-vip': {
      title: 'Baños Portátiles VIP - Alquiler para Eventos Exclusivos | Junisama',
      description: 'Alquiler de baños portátiles VIP con lavamanos interno, asiento premium y máximo confort. Ideales para bodas, eventos corporativos y ocasiones especiales en Colombia.',
      keywords: 'baños portátiles vip, alquiler baños lujo, baños eventos bodas, sanitarios premium, baños portátiles elegantes',
      url: '/servicios/banos-portatiles-vip',
      image: serviceData.mainImage || '/images/bano-portatil-vip.png',
      structuredData: createServiceSchema({
        name: 'Baño Portátil VIP',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/banos-portatiles-vip'
      })
    },
    'banos-portatiles-estandar': {
      title: 'Baños Portátiles Estándar - Alquiler Económico para Eventos | Junisama',
      description: 'Alquiler de baños portátiles estándar de calidad. Solución económica y confiable para eventos, construcciones y festivales en Colombia. Limpieza y mantenimiento incluido.',
      keywords: 'baños portátiles estándar, alquiler baños económicos, sanitarios eventos, baños construcción, baños portátiles económicos',
      url: '/servicios/banos-portatiles-estandar',
      image: serviceData.mainImage || '/images/banos-estandar-main.jpg',
      structuredData: createServiceSchema({
        name: 'Baño Portátil Estándar',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/banos-portatiles-estandar'
      })
    },
    'banos-para-discapacitados': {
      title: 'Baños para Discapacitados - Accesibilidad Garantizada | Junisama',
      description: 'Alquiler de baños portátiles para personas con discapacidad. Cumplimiento normativo, accesibilidad garantizada y espacio amplio. Inclusión en eventos en Colombia.',
      keywords: 'baños discapacitados, baños accesibles, sanitarios movilidad reducida, baños inclusivos, norma accesibilidad',
      url: '/servicios/banos-para-discapacitados',
      image: serviceData.mainImage || '/images/banos-discapacitados-main.jpg',
      structuredData: createServiceSchema({
        name: 'Baño Portátil para Discapacitados',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/banos-para-discapacitados'
      })
    },
    'banos-portatiles-electricos': {
      title: 'Baños Portátiles Eléctricos - Tecnología y Confort | Junisama',
      description: 'Alquiler de baños portátiles eléctricos con sistema de descarga automática, iluminación LED y ventilación mejorada. Tecnología de punta para eventos en Colombia.',
      keywords: 'baños portátiles eléctricos, sanitarios automáticos, baños tecnología, baños iluminación LED, baños eventos modernos',
      url: '/servicios/banos-portatiles-electricos',
      image: serviceData.mainImage || '/images/banos-electricos-main.jpg',
      structuredData: createServiceSchema({
        name: 'Baño Portátil Eléctrico',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/banos-portatiles-electricos'
      })
    },
    'lavamanos-aquastand-aquapop': {
      title: 'Lavamanos Portátiles - Higiene para Eventos | Junisama',
      description: 'Alquiler de lavamanos portátiles AquaStand y AquaPop. Soluciones de higiene para eventos, festivales y construcciones en Colombia. Dispensadores de jabón incluidos.',
      keywords: 'lavamanos portátiles, aquastand, aquapop, higiene eventos, lavamanos móviles, estaciones lavado manos',
      url: '/servicios/lavamanos-aquastand-aquapop',
      image: serviceData.mainImage || '/images/lavamanos-main.jpg',
      structuredData: createServiceSchema({
        name: 'Lavamanos Portátiles',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/lavamanos-aquastand-aquapop'
      })
    },
    'trailer-de-lujo': {
      title: 'Trailer de Lujo - Baños Premium para Eventos Exclusivos | Junisama',
      description: 'Alquiler de trailers de lujo con múltiples baños, aire acondicionado y acabados premium. La solución más elegante para eventos de alto nivel en Colombia.',
      keywords: 'trailer lujo eventos, baños móviles premium, trailer sanitario elegante, baños eventos exclusivos, trailer aire acondicionado',
      url: '/servicios/trailer-de-lujo',
      image: serviceData.mainImage || '/images/trailer-lujo-main.jpg',
      structuredData: createServiceSchema({
        name: 'Trailer de Lujo',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/trailer-de-lujo'
      })
    },
    'servicio-de-operarios': {
      title: 'Servicio de Operarios - Mantenimiento Profesional 24/7 | Junisama',
      description: 'Servicio profesional de operarios para mantenimiento y limpieza de baños portátiles durante eventos. Personal capacitado disponible 24/7 en Colombia.',
      keywords: 'operarios baños portátiles, mantenimiento eventos, limpieza sanitarios, personal capacitado, servicio 24/7',
      url: '/servicios/servicio-de-operarios',
      image: serviceData.mainImage || '/images/operarios-main.jpg',
      structuredData: createServiceSchema({
        name: 'Servicio de Operarios',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/servicio-de-operarios'
      })
    },
    'puntos-ecologicos': {
      title: 'Puntos Ecológicos - Gestión Sostenible de Residuos | Junisama',
      description: 'Alquiler de puntos ecológicos para separación de residuos en eventos. Soluciones ambientalmente responsables y cumplimiento normativo en Colombia.',
      keywords: 'puntos ecológicos, reciclaje eventos, separación residuos, gestión sostenible, contenedores reciclaje',
      url: '/servicios/puntos-ecologicos',
      image: serviceData.mainImage || '/images/puntos-ecologicos-main.jpg',
      structuredData: createServiceSchema({
        name: 'Puntos Ecológicos',
        description: serviceData.description,
        image: serviceData.mainImage,
        url: 'https://junisama.com.co/servicios/puntos-ecologicos'
      })
    }
  };

  return seoData[serviceId] || {
    title: `${serviceData.title} | Junisama`,
    description: serviceData.description,
    keywords: 'baños portátiles, sanitarios móviles, eventos Colombia',
    url: `/servicios/${serviceId}`,
    image: serviceData.mainImage,
    structuredData: createServiceSchema({
      name: serviceData.title,
      description: serviceData.description,
      image: serviceData.mainImage,
      url: `https://junisama.com.co/servicios/${serviceId}`
    })
  };
};

